import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { useSubmotive2Detail } from './hook';
import { Submotive2Data } from './data';
import { Submotive2ParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    SUBMOTIVE2_NEW,
    SUBMOTIVE2,
    SUBMOTIVE2_EDIT,
    SUBMOTIVE2_DETAIL,
} from '../../../../../routes/paths';
import { Submotive2RegisterHistory } from './registerHistory';

export const Submotive2Detail = () => {
    const {
        submotive2,
        submotive2Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive2Detail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle submotivo 2"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive2?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE2_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE2,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE2_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE2_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive2?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <Submotive2ParamsHistorical
                            historical={submotive2Historical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <Submotive2Data data={submotive2} />
                </LayoutModule>
            </LayoutModule>
            <Submotive2RegisterHistory submotive2={submotive2} />
        </>
    );
};
